import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authMutationKeys } from '../constants'

export const useLoginVerifyEmailMutation = () => {
  const handleMutation = async (token) => {
    const config = {
      method: 'post',
      data: {
        token
      }
    }

    const { data } = await api('/api/me/email/verify', config)
    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: authMutationKeys.EMAIL_MUTATION,
    retry: 0
  })
}
